<div class="layout" *ngIf="!isPageLoading">
  <form #resetPassword="ngForm" novalidate>
    <div class="card">
      <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
      <h4 style="padding: 0 0 20px;">Reset Password</h4>
      <p style="margin-bottom: 20px;font-size: 13px;">Please enter your new password</p>
      <div class="floating-label password-label">
          <input #password appBlockCopyPaste
          [allowBlock]="'true'"
          type="password" 
          [ngClass]="{'floating-input type-one': true,  'is-invalid': passwordModel.invalid}" 
          placeholder=" " 
          [value]=""
          name="password"
          [(ngModel)]="passwordValue"
          #passwordModel="ngModel"
          [pattern]="regexPassword"
          (change)="validate(password, confirmPassword, password)" required>
          <label>Password<span class="mandatory"></span></label>
          <span></span>
          <div *ngIf="passwordModel.invalid" class="invalid-feedback">
            <div *ngIf="passwordModel.errors.required">Password is required</div>
            <div *ngIf="passwordModel.errors.noMatch">Password does not match</div>
            <div *ngIf="passwordModel.errors.pattern">Passwords must be 8-20 characters, with a combination of lowercase, uppercase, numeric and special characters</div>
            <div *ngIf="passwordModel.errors.custom">{{passwordModel.errors.custom}}</div>
          </div>
      </div>
      <div class="floating-label">
          <input #confirmPassword appBlockCopyPaste
          [allowBlock]="'true'"
          type="password" 
          [ngClass]="{'floating-input type-one': true,  'is-invalid': confirmPassword.invalid}"  
          placeholder=" " 
          [value]=""
          name="confirmPassword"
          [(ngModel)]="confirmPasswordValue"
          #confirmPasswordModel="ngModel"
          [pattern]="regexPassword"
          (change)="validate(password, confirmPassword, confirmPassword)" required>
          <label>Confirm Password<span class="mandatory"></span></label>
          <span></span>
          <div *ngIf="confirmPasswordModel.invalid" class="invalid-feedback">
            <div *ngIf="confirmPasswordModel.errors.required">Confirm password is required</div>
            <div *ngIf="confirmPasswordModel.errors.noMatch">Password does not match</div>
            <div *ngIf="confirmPasswordModel.errors.pattern">Passwords must be 8-20 characters, with a combination of lowercase, uppercase, numeric and special characters</div>
            <div *ngIf="confirmPasswordModel.errors.custom">{{confirmPasswordModel.errors.custom}}</div>
          </div>
      </div>
      <button class="btn btn-primary btn-submit btn-clear" (click)="submit(password.value, confirmPassword.value)" [disabled]="!valid">Submit</button>
    </div>
  </form>
</div>

<div class="container-loader" *ngIf="isPageLoading">
    <ngx-loading [show]="isPageLoading" [config]="loaderConfig" [template]="customLoadingTemplate"></ngx-loading>
</div>
<ng-template #customLoadingTemplate>
    <div class="custom-class">
        <h4>Processing action...</h4>
    </div>
</ng-template>